import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";

const WildlifeDetails = () => {
  const [cookies] = useCookies(["token", "user", "id"]);
  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_no, setPhone] = useState("");
  const [selectedDestination, setSelectedDestination] = useState("");

  const user_id = cookies.id;

  const destinations = [
    {
      name: "Karnataka",
      img: "karnataka-wildlife.jpg",
      desc: "Home to Bandipur, Nagarhole and rich tiger reserves with lush forests.",
    },
    {
      name: "Assam",
      img: "assam-wildlife.jpg",
      desc: "Famous for Kaziranga National Park and one-horned rhinoceros.",
    },
    {
      name: "Rajasthan",
      img: "rajasthan-wildlife.jpg",
      desc: "Ranthambore and Sariska tiger reserves with royal jungle safaris.",
    },
    {
      name: "Madhya Pradesh",
      img: "mp-wildlife.jpg",
      desc: "Kanha, Bandhavgarh and Pench – the heart of Indian wildlife.",
    },
    {
      name: "Jammu And Kashmir",
      img: "jk-wildlife.jpg",
      desc: "Himalayan wildlife, alpine meadows and rare species in protected parks.",
    },
    {
      name: "Andaman Islands",
      img: "andaman-wildlife.jpg",
      desc: "Tropical forests, marine life, coral reefs and exotic bird species.",
    },
    {
      name: "Thailand",
      img: "thailand-wildlife.jpg",
      desc: "Rainforests, elephant sanctuaries and rich biodiversity.",
    },
    {
      name: "Malaysia",
      img: "malaysia-wildlife.jpg",
      desc: "Orangutans, rainforests and wildlife parks in Borneo and Peninsular Malaysia.",
    },
    {
      name: "Vietnam",
      img: "vietnam-wildlife.jpg",
      desc: "National parks, limestone forests and rare species along rivers and mountains.",
    },
  ];

  const handlePayment = async () => {
    if (!amount || !name || !email || !phone_no) {
      alert("Please fill in all fields.");
      return;
    }

    try {
      const res = await fetch(
        "https://www.api.aacoreholidaysresort.com/api/payment_details/create-order",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ amount: parseFloat(amount) }),
        },
      );

      const data = await res.json();

      const options = {
        key: "rzp_live_RAfef3cbQ27N9l",
        amount: data.amount,
        currency: data.currency,
        name: "Aacore Resorts And Hospitality Pvt. Ltd.",
        description: `${selectedDestination} Wildlife Booking`,
        order_id: data.orderId,
        handler: async function (response) {
          await fetch(
            "https://www.api.aacoreholidaysresort.com/api/payment_details/verify-payment",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                amount: parseFloat(amount),
                name,
                email,
                phone_no,
                user_id,
              }),
            },
          );

          alert("Payment successful 🎉");
          setShowModal(false);
        },
        prefill: { name, email, contact: phone_no },
        theme: { color: "#3399cc" },
      };

      new window.Razorpay(options).open();
    } catch (err) {
      alert("Payment initialization failed.");
    }
  };

  return (
    <div id="wildlifedetails">
      <div
        className="wildlifedetails-banner py-5"
        style={{
          backgroundImage: "url(/assets/images/wildlife.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.6)",
          }}
        ></div>

        <nav
          aria-label="breadcrumb"
          style={{ position: "relative", zIndex: 1 }}
        >
          <ol className="breadcrumb bg-transparent">
            <li className="breadcrumb-item">
              <Link to="/" className="text-light">
                Home
              </Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/travelthemes" className="text-light">
                Travel Theme
              </Link>
            </li>
            <li className="breadcrumb-item active text-light">Wildlife</li>
          </ol>
        </nav>
      </div>

      <div className="container mt-5">
        <h1 className="text-center mb-4">Wildlife Destinations</h1>

        <div className="row">
          {destinations.map((place, i) => (
            <div className="col-md-4 mb-4" key={i}>
              <div className="card shadow-sm" style={{ borderRadius: "10px" }}>
                <img
                  src={`/assets/images/${place.img}`}
                  className="card-img-top"
                  style={{ height: "250px", objectFit: "cover" }}
                  alt={place.name}
                />
                <div className="card-body">
                  <h5 className="card-title">{place.name}</h5>
                  <p className="card-text">{place.desc}</p>
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      setSelectedDestination(place.name);
                      setShowModal(true);
                    }}
                  >
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Book {selectedDestination} Wildlife Tour</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <input
                  className="form-control mb-2"
                  placeholder="Amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Phone"
                  value={phone_no}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
                <button className="btn btn-primary" onClick={handlePayment}>
                  Pay Now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WildlifeDetails;
